import React from 'react'
import { Tabs } from '@core/Areas/AccountActivity/types'
import {
  RacingTransactionTitleStyled,
  TransactionTabActiveStyled as TabActive,
  TransactionTabStyled as Tab,
  TransactionTabsStyled as TransactionTabs,
} from './RacingSportsTabs.styles'
import { KAMBI_PENDING_HASH_ROUTE } from '@core/Areas/KambiClient/constants'

type ActiveTabs = Tabs | 'sports'

const racingTabs: ActiveTabs[] = ['pending', 'results', 'rebet']

export const RacingSportsTabs: React.FC<{ activeTab: ActiveTabs; isRacing?: boolean }> = ({
  isRacing,
  activeTab,
}) => {
  const RacingTab = racingTabs.includes(activeTab) ? TabActive : Tab
  const SportsTab = activeTab === 'sports' ? TabActive : Tab
  const TransactionTab = activeTab === 'transactions' ? TabActive : Tab
  return (
    <>
      <TransactionTabs>
        <RacingTab data-testid='account-activity-tab-racing' to='/account/activity/pending'>
          Racing Bets
        </RacingTab>

        <SportsTab data-testid='account-activity-tab-sports' to={`${KAMBI_PENDING_HASH_ROUTE}`}>
          Sports Bets
        </SportsTab>

        <TransactionTab
          data-testid='account-activity-tab-transactions'
          to='/account/activity/transactions'
        >
          Debit / Credit
        </TransactionTab>
      </TransactionTabs>

      {isRacing && (
        <RacingTransactionTitleStyled>
          <h1 data-testid='account-activity-transactions-title'>
            My {activeTab === 'transactions' ? 'Debit / Credit' : 'Racing Bets'}
          </h1>
        </RacingTransactionTitleStyled>
      )}
    </>
  )
}
